import {
  PlatformsPostRequest,
  PlatformsPlatformIdPatchRequest,
  PlatformsPlatformIdDeleteRequest,
} from '@nativewaves/nw-cloud-sdk/media'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { MediaAPI } from 'services/api'
import { mediaPlatformQueryKeys } from 'services/queryKeys/media'

export const useMediaPlatformCreateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: PlatformsPostRequest) => MediaAPI.mediaPlatforms.platformsPost(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: mediaPlatformQueryKeys.lists() })
    },
  })
}

export const useMediaPlatformUpdateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: PlatformsPlatformIdPatchRequest) => MediaAPI.mediaPlatforms.platformsPlatformIdPatch(params),
    onSuccess: (data) => {
      return Promise.allSettled([
        queryClient.invalidateQueries({ queryKey: mediaPlatformQueryKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: mediaPlatformQueryKeys.detail({ platformId: data.id }).queryKey }),
      ])
    },
  })
}

export const useMediaPlatformDeleteMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: PlatformsPlatformIdDeleteRequest) => MediaAPI.mediaPlatforms.platformsPlatformIdDelete(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: mediaPlatformQueryKeys.lists() })
    },
  })
}
